import {TFieldType, Util} from "./util";
import {
    TBrandedQuem,
    TBrandedTipo,
    THotpageContent,
    TProfileSexo,
    TImageModel,
    ENUM,
} from "./enum";
import {InitParams} from "ngx-facebook";

interface RGB {r: number; g: number; b: number}

export class CONFIG {

    static data = {
        version: '5.22.1',

        device: null,

        brandap: null,

        facebookScope: 'email,user_birthday,user_gender,user_location,user_hometown,user_link',//,user_friends',

        pictureFotoQuality: 90,
        pictureFaceWidth: 200,
        pictureFaceHeight: 200,
        pictureBodyWidth: 400,
        pictureBodyHeight: 800,

        ellzitoID: 10000000,
        fakecadID: 10000291
    };

    static colors = {

        /** PRIMÁRIA - AMARELO **/
        CorGold: '#ffd200', // { 255 | 210 | 000 }
        CorOuro: '#ebb932', // { 235 | 185 | 050 }
        CorWeek: '#ffb43a', // { 255 | 180 | 058 }
        CorTera: '#f5a023', // { 245 | 160 | 035 }

        CorLand: '#f0c864', // { 240 | 200 | 100 }
        CorCoco: '#d7b478', // { 215 | 180 | 120 }
        CorCret: '#91876e', // { 145 | 135 | 110 }
        CorShet: '#aa8c28', // { 170 | 140 | 040 }        
        CorCafe: '#a5704b', // { 165 | 112 | 075 }
        CorCofe: '#5f3714', // { 095 | 055 | 020 }
        CorIsco: '#73280a', // { 115 | 040 | 010 }

        CorPaya: '#ff8c00', // { 255 | 140 | 000 }
        CorFogo: '#ff7d41', // { 255 | 125 | 065 }
        CorFire: '#e14f27', // { 255 | 080 | 040 }
        CorBoca: '#ff5064', // { 255 | 080 | 100 }
        
        /** PRIMÁRIA - VERMELHO **/
        //CorFlix ???
        CorAmor: '#f00a50', // { 240 | 010 | 080 }
        CorTube: '#ff0000', // { 255 | 000 | 000 }
        CorVerm: '#c83737', // { 200 |  55 |  55 }
        CorFood: '#be1e28', // { 190 | 030 | 040 }
        CorPuta: '#870000', // { 135 | 000 | 000 }

        CorPink: '#ff00f5', // { 255 | 000 | 245 }
        CorSete: '#ff2882', // { 255 | 040 | 130 }
        CorRosa: '#ca59a2', // { 200 | 090 | 160 }
        CorAcai: '#c85aa0', // { XXX | XXX | XXX }
        CorPele: '#fa91a0', // { 250 | 145 | 160 }

        /** SECUNDÁRIA - ROXA **/
        CorRoxa: '#7332ff', // { 115 |  50 | 255 }
        CorRoxo: '#7819f0', // { 120 |  25 | 240 }
        CorRoxi: '#8246ff', // { 130 |  70 | 255 }
        CorRoxu: '#9632ff', // { 150 |  50 | 255 }

        /** PRIMÁRIA - AZUL **/
        CorOmie: '#00e1f5', // { 000 | 225 | 245 }
        CorTwit: '#00acee', // { 000 | 172 | 238 }
        CorNemo: '#237dc8', // { 035 | 125 | 200 }
        CorAzul: '#3b5998', // { 059 | 089 | 152 }
        CorBlue: '#0078ff', // { 000 | 120 | 255 }

        CorAqua: '#00fadc', // { 000 | 250 | 220 }
        CorAque: '#00c8aa', // { 000 | 200 | 170 }
        CorAbra: '#419bb4', // { 065 | 155 | 180 }
        CorTeee: '#007d78', // { 000 | 125 | 120 }
        CorTree: '#4b6469', // { 075 | 100 | 105 }

        /** SECUNDÁRIA - VERDE **/
        CorLimo: '#f0f064', // { 240 | 240 | 100 }
        CorBema: '#c3dc41', // { 195 | 220 | 065 }
        CorLemo: '#87c300', // { 135 | 195 | 000 }
        CorWhat: '#25d366', // { 037 | 211 | 102 }
        CorMato: '#37b46e', // { 055 | 180 | 110 }
        CorLime: '#00ff00', // { 000 | 255 | 000 }
        CorLima: '#beff00', // { 190 | 255 | 000 }
        CorGren: '#008000', // { 000 | 080 | 000 }
        CorGree: '#194b37', // { 025 | 075 | 055 }
        CorMusg: '#415014', // { 065 | 080 | 020 }

        /** MONOCROMÁTICO **/
        CorNego: '#000000', // { 000 | 000 | 000 }
        CorDark: '#20202c', // { 032 | 032 | 044 } //AKI-DARK-MODE
        CorGray: '#3d3d3d', // { 061 | 061 | 061 }
        CorDash: '#3e414c', // { 062 | 065 | 076 } //AKI-DARK-MODE
        CorMenu: '#434551', // { 067 | 069 | 081 }
        CorText: '#737373', // { 115 | 115 | 115 } '#696969', // { 105 | 105 | 105 }
        CorHold: '#969696', // { 150 | 150 | 150 }
        CorInox: '#b4b4b4', // { 180 | 180 | 180 }
        CorGelo: '#c8c8c8', // { 200 | 200 | 200 }
        CorNeve: '#e6e6e6', // { 230 | 230 | 230 }
        CorIced: '#f0f0f0', // { 240 | 240 | 240 }
        CorSnow: '#fafafa', // { 250 | 250 | 250 }
        CorMilk: '#ffffff', // { 255 | 255 | 255 }
        CorNada: '#ffffff00', // { 255 | 255 | 255 }

        CorFacebook: '#1876f2', // { 024 | 119 | 242 }  //DELETE

    };

    static paths = {
        bridge: '',
        bridgePorta: '',
        bridgeMainway: 'https://bridge.lorean.com.br',
        bridgeSupport: 'https://support.lorean.com.br',
        bridgeRededez: 'http://192.168.1.5',
      //bridgeRededez: 'http://10.0.0.5',

        hostLorean: 'www.lorean.com.br',
        hostStorage: 'storage.lorean.com.br',

        httpLorapp: 'https://lorean.app',
        httpLorean: 'https://www.lorean.com.br',
        httpStorage: 'https://storage.lorean.com.br',

        fotoGhost: 'https://storage.lorean.com.br/profile/00000000/ghost.png',
        fotoGhust: 'https://storage.lorean.com.br/profile/00000000/ghust.png',

        appStoreID: 'id730820569',
        appStoreLink: 'https://apps.apple.com/br/app/lorean/id730820569',

        playStoreID: 'com.lorean.app',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.lorean.app',

        pushBrowserApi: 'http://push.api.phonegap.com/v1/push',
    };

    static request = {
        retryDelay: 5000, // apenas em req. seguras p/ retries
        totalTimeout: 30000, // todas req.
        timeoutErroPadrao: {Titulo: 'Timeout', Result: 'Verifique sua conexão'},
        bridgeErroPadrao: {Titulo: 'Internet', Result: 'Verifique sua conexão'},
        monitorErroPadrao: {Titulo: 'Wifi', Result: 'Verifique sua conexão'},

        showDeskInterval: 30000
    };

    static geolocation = {
        timeout: 20000,     // Timeout - Tentativa de obter geolocation
        frequency: 300000,  // 5min - Tempo de atualização durante o uso do app (antes estava 30seg, trocado pois não há necessidade)
        radius: 20,         // Radius
        distance: 50000,    // Distância 50km
    };


    //Spotus -> Olha
    static spotus = {

        HotspotID: 1000,

        BrandedID: 10000,
        BrandedNome: 'Olha',
        BrandedShow: 'Olha',
        BrandedCity: 'SP - Bauru',
        BrandedQuem: TBrandedQuem.whNone,
        BrandedTipo: TBrandedTipo.btMarca,
        BrandedSexo: TProfileSexo.psNenhum,
        BrandedSoma: true,
        BrandedPage: false,
        BrandedCora: 'CorRoxa',
        BrandedAppb: 'lorean.com.br',
        BrandedClid: '',
        BrandedScrt: '',
        BrandedBase: 'https://storage.lorean.com.br/branded/10000/base.png?a',
        BrandedIcon: 'https://storage.lorean.com.br/branded/10000/icon.png?a',
        BrandedLogo: 'https://storage.lorean.com.br/branded/10000/logo.png?a',
        BrandedSymb: 'https://storage.lorean.com.br/branded/10000/symb.png?a',
        BrandedSputs: [],

        Interface: {
            googleAnalyticsId: 'UA-7116284-4',
            braspagOrgId: 'k8vif92e',
            facebookAppId: '392897730772494',
            facebookPage: '152404478170291',
            facebookVersion: 'v3.1',
            gcm_id: '395573764067',
        }

    };

    //Kairos -> Kairus
    static kairos = {

        HotspotID: 1001,

        BrandedID: 20000,
        BrandedNome: 'Kairus',
        BrandedShow: 'Kairus Software',
        BrandedCity: 'SP - Bauru',
        BrandedQuem: TBrandedQuem.whNone,
        BrandedTipo: TBrandedTipo.btMarca,
        BrandedSexo: TProfileSexo.psNenhum,
        BrandedSoma: true,
        BrandedPage: false,
        BrandedCora: 'CorGold',
        BrandedAppb: 'kairus.com.br',
        BrandedClid: '',
        BrandedScrt: '',
        BrandedBase: 'https://storage.lorean.com.br/branded/10000/base.png',
        BrandedIcon: 'https://storage.lorean.com.br/branded/10000/icon.png',
        BrandedLogo: 'https://storage.lorean.com.br/branded/10000/logo.png',
        BrandedSymb: 'https://storage.lorean.com.br/branded/10000/symb.png',
        BrandedSputs: [],

        Interface: {
            googleAnalyticsId: '',
            braspagOrgId: '',
            facebookAppId: '',
            facebookPage: '',
            facebookVersion: '',
            gcm_id: '',
        }

    };

    static gatewey = {
        GateweyID: 14000,
        GateweyCoin: 0,
        GateweyCent: 0,
        Branded: null,
    };

    static departa = {
        DepartaID: 100,
        DepartaNome: "Presidência",
        DepartaNick: "CEO",
    };

    static iface(): InitParams {

        let initParams: InitParams = {
            appId: CONFIG.spotus.Interface.facebookAppId,
            xfbml: true,
            version: CONFIG.spotus.Interface.facebookVersion
        };

        return initParams;

    }

    static rgbToHex(rgb: RGB): string {
        return "#" + (
            (1 << 24) + // to get leading zeroes on r if needed
            (rgb.r << 16) + (rgb.g << 8) + rgb.b)
            .toString(16) // hexify
            .slice(1); // and strip off that artificial '1' we put on the front
    }

    static hexToRgb(hex: string): RGB {
        if (!hex) return {r: 0, g: 0, b: 0};

        hex = hex.replace(/^#/, "");
        // support short-version with one nybble per chroma by expanding 'x' to 'xx'
        hex = hex.length === 3 ? hex.replace(/(.)/g, "$1$1") : hex;

        return {
            r: parseInt(hex.substr(0, 2), 16),// / 255,
            g: parseInt(hex.substr(2, 2), 16),// / 255,
            b: parseInt(hex.substr(4, 2), 16),// / 255
        };
    }

    
    static inverteTint(tint) {

        if (tint == 'CorRoxa') return this.colors['CorLime'];
        if (tint == 'CorLime') return this.colors['CorRoxa'];
        return this.inverteHexa(this.colors[tint]);

    }

    static inverteHexa(hex) {

        if (hex.indexOf('#') === 0) hex = hex.slice(1);

        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];

        if (hex.length !== 6) throw new Error('Invalid HEX color.');

        // invert color components
        var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
            g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
            b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);

        // pad each with zeros and return
        return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);

    }
    
    static padZero(str, len?) {

        len = len || 2;
        var zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);

    }

    static negative(backColor, fontWhite: string = 'CorMilk', fontPreto: string = 'CorDash'): string {

        if (!this.colors[backColor]) return fontWhite;

        //especiais
        if (backColor == 'CorAqua') return fontPreto;
        if (backColor == 'CorPink') return fontWhite;


        let hex = this.colors[backColor];
        if (hex.indexOf('#') === 0) hex = hex.slice(1);

        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];

        let intR = (parseInt(hex.slice(0, 2), 16));
        let intG = (parseInt(hex.slice(2, 4), 16));
        let intB = (parseInt(hex.slice(4, 6), 16));
      //let bool = (intR >= 170) && (intG >= 170) && (intB >= 170);
        let bool = ((intR+intG+intB)/3 >= 160) || (intR == 0 && intG == 255 && intB == 0);

        return (bool ? fontPreto : fontWhite);

    }

    static negativo(backColor, fontWhite: string = 'CorMilk'): string {

        if (backColor == fontWhite) return 'CorDash';
        return backColor;

    }

    static cieloCode(code): string {

        if (code == '-1') return 'Problemas com a Cielo.';         //Aprovada Nacional                            - APROVADA!
        if (code == '00') return 'Transação autorizada.';
        if (code == '01') return 'Transação referida emissor.';    //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '04') return 'Transação não autorizada.';      //Existe algum tipo de restrição no cartão     - Oriente o portador a refazer a transação
        if (code == '05') return 'Transação não autorizada.';      //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '06') return 'Tente novamente.';               //Falha na autorização                         - Oriente o portador a refazer a transação
        if (code == '07') return 'Cartão com restrição.';          //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '08') return 'Código de segurança inválido.';  //Código de segurança incorreto.               - Oriente o portador a refazer a transação digitando o código de segurança corretamente
        if (code == '11') return 'Transação autorizada.';          //Aprovada Internacional                       - APROVADA!
        if (code == '12') return 'Cartão de débito.';              //Operação do cartão inválida.                 - Compra débito com cartão que só aceita crédito, ou vice-versa
        if (code == '13') return 'Valor inválido.';                //Valor Inválido.                              - Oriente o portador a refazer a transação digitando o valor correto (Verifique valor mínimo de R$5,00 para parcelamento)
        if (code == '14') return 'Cartão inválido.';               //Digitação incorreta do número do cartão      - Oriente o portador a verificar o número do cartão e digitar novamente
        if (code == '15') return 'Banco emissor indisponível.';    //Banco emissor indisponível.                  - Oriente o portador a aguardar alguns instantes e tentar novamente
        if (code == '19') return 'Repita a Transação.';            //Banco emissor com problema tecnico.          - Oriente o portador a aguardar alguns instantes e tentar novamente
        if (code == '21') return 'Cancelamento não efetuado.';     //Cancelamento não localizado no banco emissor - O estabelecimento deve entrar em contato com a Central de Relacionamento Cielo
        if (code == '38') return 'Excedido tentativa de senha.';   //Excedido tentativa de senha.                 - Oriente o portador a contatar o banco emissor do cartão
        if (code == '41') return 'Cartão com restrição.';          //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão (Cartão Extraviado: que já foi cancelado na administradora do cartão e no banco)
        if (code == '43') return 'Cartão roubado.';                //Cliente fez reclamação de roubo do cartão    - Oriente o estabelecimento a contatar a polícia
        if (code == '51') return 'Saldo insuficiente.';            //Saldo insuficiente.                          - Oriente o portador a contatar o banco emissor do cartão
        if (code == '54') return 'Cartão vencido.';                //Cartão vencido.                              - Oriente o portador a verificar o vencimento do cartão e digitar novamente
        if (code == '55') return 'Senha incorreta.';               //Senha incorreta.                             - Oriente o portador a verificar a senha e digitar novamente, na terceira tentativa vem a mensagem 38 = cartão bloqueado.
        if (code == '57') return 'Transação não permitida.';       //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '60') return 'Transação não autorizada.';      //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '61') return 'Excedido limite de compra.';     //Existe algum tipo de limite no cartão        - Oriente o portador a contatar o banco emissor do cartão
        if (code == '62') return 'Transação não autorizada.';      //Existe algum tipo de restrição no cartão     - Oriente o portador a contatar o banco emissor do cartão
        if (code == '78') return 'Cartão não desbloqueado.';       //Cartão não foi desbloqueado pelo portador    - Oriente o portador a desbloquear o cartão junto ao emissor do cartão
        if (code == '82') return 'Erro no cartão.';                //Cartão Inválido                              - Oriente o portador a verificar o número do cartão e digitar novamente
        if (code == '91') return 'Banco fora do ar.';              //Banco emissor indisponível                   - Oriente o portador a aguardar alguns instantes e tentar novamente
        if (code == '96') return 'Tente novamente.';               //Falha no envio da autorização                - Oriente o portador a aguardar alguns instantes e tentar novamente


        /** Codigos que não estão no manual da Cielo **/
        //if (code == '12') return 'Transação inválida.';
        if (code == '63') return 'Cartão com restrição.';
        if (code == '76') return 'Tente novamente.';

        return 'Código não identificado.';

    };

    static plateobject(content: THotpageContent = null): any {

        let hotlove = 'Hotlove for you %ProfileShow%';

        let hc = THotpageContent;

        let imaged = {Source: null, Opacit: 1.0,  Scroll: 'Scroll',  Grayed: false, Adjust: false};
        let movied = {Source: null, Opacit: 1.0,  Scroll: 'Scroll',  Grayed: false, Adjust: false};
        let molded = {Source: null, Sizing: 80, Padtop: 0, Padbot: 0};

        let vouchery = '../assets/img/background/bg-voucher.png';
        let birthday = '../assets/img/background/bg-birthday.jpg';
        if (content == THotpageContent.hcAction)   imaged = {Source: '',        Opacit: 1.0, Scroll: 'SCover', Grayed: false, Adjust: false};
        if (content == THotpageContent.hcMeritum)  imaged = {Source: '#Symb',   Opacit: 0.1, Scroll: 'Mixed',  Grayed: true,  Adjust: false};
        if (content == THotpageContent.hcLogado)   imaged = {Source: '#Symb',   Opacit: 0.1, Scroll: 'Repeat', Grayed: true,  Adjust: false};
        if (content == THotpageContent.hcVoucher)  imaged = {Source: vouchery,  Opacit: 1.0, Scroll: 'Repeat', Grayed: true,  Adjust: false};
        if (content == THotpageContent.hcBirthday) imaged = {Source: birthday,  Opacit: 1.0, Scroll: 'Scroll', Grayed: true,  Adjust: false};

        //let source = 'https://www.w3schools.com/howto/rain.mp4';
        //movied = {Source: source, Opacit: '10%', Scroll: 'Scroll', Grayed: true, Adjust: false};

        return {
            Layout: [
                /** hcAction    **/ ['Layout 1'],
                /** hcBanner    **/ ['Layout 1'],
                /** hcSocial    **/ ['Layout 1'],
                /** hcCheckin   **/ ['Layout 1', 'Layout 2'],
                /** hcBirthday  **/ ['Layout 1'],
                /** hcBranded   **/ ['Layout 1'],
                /** hcDelivery  **/ ['Layout 1'],
                /** hcVoucher   **/ ['Layout 1'],
                /** hcEvento    **/ ['Layout 1', 'Layout 2'],
                /** hcLogado    **/ ['Layout 1'],
                /** hcNotice    **/ ['Layout 1'],
                /** hcPlace     **/ ['Layout 1'],
                /** hcPhoto     **/ ['Layout 1', 'Layout 2'],
                /** hcVideo     **/ ['Layout 1'],
                /** hcMusic     **/ ['Layout 1'],
                /** hcMusical   **/ ['Layout 1'],
                /** hcMeritum   **/ ['Layout 1'],
                /** hcHotlove   **/ ['Layout 1'],
                /** hcFriendy   **/ ['Layout 1'],
                /** hcUsuario   **/ ['Layout 1', 'Layout 2'],
                /** hcAddress   **/ ['Layout 1'],
            ],

            Inside: [
                {group: hc.hcAction,   array: [hc.hcSocial]},
                {group: hc.hcBanner,   array: []},
                {group: hc.hcCheckin,  array: [hc.hcSocial, hc.hcVoucher, hc.hcDelivery, hc.hcEvento, hc.hcMeritum]},
                {group: hc.hcSocial,   array: [hc.hcCheckin, hc.hcEvento]},
                {group: hc.hcBirthday, array: [hc.hcLogado, hc.hcVoucher, hc.hcFriendy]},
                {group: hc.hcBranded,  array: [hc.hcSocial, hc.hcDelivery, hc.hcMeritum, hc.hcUsuario]},
                {group: hc.hcDelivery, array: [hc.hcCheckin, hc.hcSocial]},
                {group: hc.hcVoucher,  array: [hc.hcCheckin, hc.hcEvento, hc.hcFriendy]},
                {group: hc.hcEvento,   array: [hc.hcCheckin, hc.hcDelivery, hc.hcVoucher, hc.hcMusic, hc.hcPlace]},
                {group: hc.hcLogado,   array: [hc.hcCheckin, hc.hcDelivery, hc.hcVoucher, hc.hcMeritum, hc.hcFriendy, hc.hcBirthday]},
                {group: hc.hcNotice,   array: [hc.hcPhoto, hc.hcVideo, hc.hcMusic]},
                {group: hc.hcPlace,    array: [hc.hcBranded, hc.hcVideo, hc.hcNotice, hc.hcUsuario, hc.hcFriendy]},
                {group: hc.hcPhoto,    array: [hc.hcPlace, hc.hcVideo, hc.hcMusic, hc.hcFriendy]},
                {group: hc.hcVideo,    array: [hc.hcPlace, hc.hcPhoto, hc.hcMusic, hc.hcFriendy]},
                {group: hc.hcMusic,    array: [hc.hcPhoto, hc.hcVideo, hc.hcMusical, hc.hcEvento, hc.hcUsuario]},
                {group: hc.hcMusical,  array: [hc.hcPlace, hc.hcPhoto, hc.hcVideo, hc.hcMusic, hc.hcUsuario]},
                {group: hc.hcMeritum,  array: [hc.hcSocial, hc.hcVoucher, hc.hcHotlove, hc.hcBranded]},
                {group: hc.hcHotlove,  array: [hc.hcSocial, hc.hcVoucher, hc.hcCheckin, hc.hcLogado, hc.hcEvento, hc.hcNotice, hc.hcPlace, hc.hcPhoto, hc.hcVideo, hc.hcMusic]},
                {group: hc.hcFriendy,  array: [hc.hcBirthday, hc.hcPlace]},
                {group: hc.hcUsuario,  array: [hc.hcBranded, hc.hcPlace]},
                {group: hc.hcAddress,  array: []},
            ],

            Header: {Corone: 'CorDash',  Cortwo: 'CorDash',  Fonted: 'Gotham', Weight: 900, Molded: molded, Textod: [
                    /** hcAction    **/ [null],
                    /** hcBanner    **/ [null],
                    /** hcSocial    **/ [null],
                    /** hcCheckin   **/ ['%CheckinStatis%', 'Avaliaram a gente assim'],
                    /** hcBirthday  **/ ['Parabéns %ProfileShow%'],
                    /** hcBranded   **/ ['Marcas'],
                    /** hcDelivery  **/ ['Delivery'],
                    /** hcVoucher   **/ ['Confira seu Voucher'],
                    /** hcEvento    **/ ['Programação'],
                    /** hcLogado    **/ ['Bem-vindo!', 'Bem-vindo, %ProfileShow%'],
                    /** hcNotice    **/ ['Notícia'],
                    /** hcPlace     **/ ['Estrutura'],
                    /** hcPhoto     **/ ['Fotos'],
                    /** hcVideo     **/ ['Assista'],
                    /** hcMusic     **/ ['Ouça agora!'],
                    /** hcMusical   **/ ['Cachê', '%MusicalCoin%', 'TOP BAND PREMIUM'],
                    /** hcMeritum   **/ ['Meritum'],
                    /** hcHotlove   **/ [hotlove],
                    /** hcFriendy   **/ ['Friend on spot'],
                    /** hcUsuario   **/ ['Quem Somos'],
                    /** hcAddress   **/ ['Onde Estamos?'],
                ]},

            Resume: {Corone: 'CorText',  Cortwo: 'CorText',  Fonted: 'Gotham', Weight: 400, Molded: molded, Textod: [
                    /** hcAction    **/ [null],
                    /** hcBanner    **/ [null],
                    /** hcSocial    **/ [null],
                    /** hcCheckin   **/ ['Você poderia nos avaliar?<br/>Sua opinião é muito importante para nós.', 'Queremos sempre o melhor<br/>Confira nossa performance.'],
                    /** hcBirthday  **/ ['Aproveite bem o seu dia!<br/>Reservamos algumas surpresas pra você!'],
                    /** hcBranded   **/ ['Conheça tudo acessando'],
                    /** hcDelivery  **/ ['Faça seu pedido online'],
                    /** hcVoucher   **/ ['Instale o spotUS para utilizar'],
                    /** hcEvento    **/ ['Confira os próximos eventos'],
                    /** hcLogado    **/ ['Faça o login e tenha acesso<br/>ao conteúdo completo!',                  'Aqui você tem o controle das<br/>suas informações!'],
                    /** hcNotice    **/ ['Saiu do forno e está quentinho'],
                    /** hcPlace     **/ ['Nosso lugar preparado para você'],
                    /** hcPhoto     **/ ['Fotos das pessoas que curtiram'],
                    /** hcVideo     **/ ['Preparamos nossos videos com carinho'],
                    /** hcMusic     **/ ['Nosso estilo é esse :)'],
                    /** hcMusical   **/ ['a partir de', 'Tipo de evento e estrutura definem o valor.', '30 shows confirmados'],
                    /** hcMeritum   **/ ['Categoria de Card e Seal'],
                    /** hcHotlove   **/ ['Obrigado por tornar nós como seu lugar favorito!'],
                    /** hcFriendy   **/ ['Eles já marcaram presença aqui'],
                    /** hcUsuario   **/ ['Nosso time trabalha para você'],
                    /** hcAddress   **/ [null],
                ]},

            Button: {Corone: 'CorDash',  Cortwo: 'CorDash',  Fonted: 'Gotham', Weight: 600, Textod: [
                    /** hcAction    **/ [null],
                    /** hcBanner    **/ [null],
                    /** hcSocial    **/ [null],
                    /** hcCheckin   **/ ['Avaliar', null],
                    /** hcBirthday  **/ ['Saiba Mais'],
                    /** hcBranded   **/ ['XXX'],
                    /** hcDelivery  **/ ['Fazer Pedido'],
                    /** hcVoucher   **/ ['Ver Voucher'],
                    /** hcEvento    **/ [null],
                    /** hcLogado    **/ ['Entrar', 'Acesse seu perfil'],
                    /** hcNotice    **/ ['Mais Notícias'],
                    /** hcPlace     **/ ['Mais Álbuns'],
                    /** hcPhoto     **/ ['Mais Álbuns'],
                    /** hcVideo     **/ ['Mais Vídeos'],
                    /** hcMusic     **/ [null],
                    /** hcMusical   **/ ['Tenho Interesse', null, null],
                    /** hcMeritum   **/ ['XXX'],
                    /** hcHotlove   **/ [null],
                    /** hcFriendy   **/ [null],
                    /** hcUsuario   **/ [null],
                    /** hcAddress   **/ ['Chegar lá'],
                ],
                Fill: 'Outline', Size: 'Default', Clip: null, Shape: 'Square'},

            Spacer: {Corone: 'CorGelo', Cortwo: 'CorGelo', Estilo: 'Square', Height: 0},

            Ground: {Corone: null,      Cortwo: null,      Imaged: imaged,   Movied: movied}, //Onlypc: null},
        }

    };

    static plateroot(branded, rootname: 'Logotipo' | 'Logotint') {

        let result = branded.BrandedBody.Hspot[rootname];
        let pintar = branded.BrandedBody.Hspot.Logotint;
        let icones = (branded.BrandedBody.Hspot.Logotipo == '#Icon');

        if (rootname == 'Logotipo') {
            if ( icones) return (pintar ? branded.BrandedIcon : branded.BrandedSymb);
            if (!icones) return (pintar ? branded.BrandedBase : branded.BrandedLogo);
        }

        if (rootname == 'Logotint') {
            if (result == null)      result = '';
            if (result == '#Corone') result = branded.BrandedCora;
            //if (result == 'Cor????') result = 'Cor????';
        }

        return result;
    }

    static platenode(branded, blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground', rootnome: 'Corone' | 'Cortwo' | 'Fonted' | 'Weight' | 'Textod' | 'Molded' | 'Fill' | 'Size' | 'Clip' | 'Shape' | 'Estilo' | 'Height' | 'Imaged' | 'Movied', rootfile: 'Source' | 'Opacit' | 'Scroll' | ' Grayed' = null, tag: number = 0, hpage: any = null, meritum: any = null): string {

        if (!blocked) return;
        
        let plate = this.plateobject(blocked.Content);

        let plateddy = plate[rootname][rootnome];
        let blockedy = blocked[rootname][rootnome];

        let text = (rootnome == 'Textod');
        let file = (rootnome == 'Molded' || rootnome == 'Imaged' || rootnome == 'Movied');
        let full = (!text && !file);

        let result = '';
        if (full) result = (blockedy != null ? blockedy           : plateddy);
        if (text) result = (blockedy != null ? blockedy           : plateddy[blocked.Content][tag]);
        if (file) result = (blockedy != null ? blockedy[rootfile] : (!plateddy ? null : plateddy[rootfile]));

        if (text && result && hpage && hpage.logado && hpage.util) {
            let coin = (2505).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
            let show = (!hpage.perfil ? '' : hpage.util.nomeFirst(hpage.perfil.Profile.ProfileShow));
            let nome = (!meritum ? '' : meritum.Branded.BrandedNome);

            result = result.replace('%ProfileShow%', show);
            result = result.replace('%MusicalCoin%', coin);
            result = result.replace('%BrandedNome%', nome);
            result = result.replace('%BrandedShow%', nome);
        }

        if (rootname == 'Ground' && rootnome == 'Imaged' && rootfile == 'Source') {
            let brended = (blocked.Content == THotpageContent.hcMeritum && meritum ? meritum : branded);
            if (result == '#Symb') result = brended.BrandedIcon;
            if (result == '#Logo') result = brended.BrandedBase;
        }

        //rootnome == 'Corone' || 'Cortwo'
        if (result == '#Corone') result = branded.BrandedCora;
        if (result == '#Cortwo') result = branded.BrandedCora;

        //if (blocked.Content == THotpageContent.hcAction && rootfile == 'Opacit') {}

        return result;

    }

    static platestyled(blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground'): any {

        let plate = this.plateobject(null);
        let color = (blocked[rootname].Corone ? blocked[rootname].Corone : plate[rootname].Corone);// plate.corone);
        let fonte = (blocked[rootname].Fonted ? blocked[rootname].Fonted : plate[rootname].Fonted);// plate.fonted);
        let weigh = (blocked[rootname].Weight ? blocked[rootname].Weight : plate[rootname].Weight);// plate.weight);
        return {color: this.colors[color], 'font-family': fonte, 'font-weight': weigh};

    }

    static isAmbiente(util: Util, flags: string[], operator: string = ''): boolean {

        let beel = (operator != 'and');
        let bool: boolean = !beel;

        let hostname = window.location.hostname.replace('www.', '');

        let mykit = this.data.brandap;
        let loweb = (!mykit && !util.nativeApp());
        let brows = (mykit && !util.nativeApp() && mykit.BrandedAppb == hostname);

        flags.forEach((flag) => {
            if (flag == 'mykit' && (beel != !mykit)) bool = beel;
            if (flag == 'loweb' && (beel != !loweb)) bool = beel;
            if (flag == 'myweb' && (beel != !brows)) bool = beel;
        });

        return bool;

    }

    static listingForm(window, onShow: any, onOkuy: any, alignL: any = null, alignC: any = null, alignR: any = null, corcor: string = null, button: any = null, opened: boolean = false, modelo: TImageModel = null, action: any = null, onBack: any = null) {

        /** MODAL-TYPE **/
        //'html' | 'text' | 'bttn' | 'foto' | 'logo' | 'icon' | 'rank' | 'mark'

        if (!alignL) alignL = {type: 'foto', text: '', show: ['Profile', 'ProfileFace'], info: '', color: ''};
        if (!alignC) alignC = {type: 'text', text: '', show: ['Profile', 'ProfileShow'], info: '', color: ''};
        if (!alignR) alignR = {type: 'none', text: '', show: '',                         info: '', color: ''};
        if (!corcor) corcor = 'CorMilk';
        if (!modelo) modelo = TImageModel.imLista;

        return {
            modelo: modelo,
            window: window,
            corcor: corcor,
            header: null,
            titulo: null,
            resumo: null,
            imagem: null,
            radius: null,
            molder: null,
            avatar: 'small',
            cormain: null,

            alignL: alignL,
            alignC: alignC,
            alignR: alignR,

            opened: opened,
            button: button,
            action: action,

            onShow: onShow,
            onOkuy: onOkuy,
            onBack: onBack,
        }

    };

    static modalSlide(header: string, titulo: string, resumo: string, imagem: string, corcor: string = null, groups: any[]): any {

        if (!corcor) corcor = 'CorMilk';

        return {
            corcor: corcor,
            header: header,
            titulo: titulo,
            resumo: resumo,
            imagem: imagem,
            groups: groups,
        };

    }

    static modalGroup(titulo: string, fields: any[]): any {

        return {
            titulo: titulo,
            fields: fields
        };

    }

    static modalField(type: TFieldType, title: string, texto: string, limit: {min: number | string, max: number | string, pos: number | string}, value: any = null, items: any[], options: any = null, disabled: boolean = false): any {

        if (!limit && type != TFieldType.ftDate) limit = {min: 0, max: 0, pos: 0};
        if (!limit && type == TFieldType.ftDate) limit = {min: '', max: '', pos: ''};

        if (type == TFieldType.ftDate && value) value = value.split(' ')[0];

        return {
            type: type,
            title: title,
            texto: texto,
            icone: 'b-icon-fire-2',
            limit: limit,
            value: value,
            items: items,
            anime: '', //animecss
            options: options,
            disabled: disabled,
        };

    }

    static modalChild(title: string, value: string, icone: string, items: any[] = null): any {

        return {
            title: title,
            value: value,
            icone: icone,
            items: items,
        };

    }

    static modalSheet(title: string, value: string): any {

        return {
            title: title,
            value: value,
        };

    }

    static modalBotao(icone, title, value: any): any {

        let object: any[] = [];
        value.forEach( texto => object.push({title: texto}));
        return {icon: icone, title: title, value: object}

    };

    static modalinfo(util: Util, window, onOkey: any = null, onPlus: any = null, bool: boolean = false, data: any = null, observ: any = null): any {

        let str= '';
        if (typeof data == 'string') str = data;

        let memberuser = {corcor: 'CorFood', usuario: {Profile: {ProfileShow: ''}, Departa: {DepartaNome: '', DepartaNick: ''}, UsuarioRole: 0, UsuarioHtml: ''}};
        if (window == 'memberuser' && data) memberuser.usuario = data.usuario;

        if (!data) data = {};

        let resultData = {

            cashflow: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: 'CASHFLOW',
                resumo: 'O fluxo de caixa é o movimento de entrada e saída de recursos financeiros. A entrada de recursos é proveniente das atividades de venda de produtos/serviços ou da venda de algum ativo (equipamento, veículo, imóvel, por exemplo).' +
                    '<br><br>' +
                    'Quando a entrada de recursos é maior do que a saída, temos um saldo positivo, caracterizando uma situação superavitária. Por outro lado, quando a saída de recursos é maior do que a entrada, temos uma situação deficitária.' +
                    '<br><br>' +
                    'Um fluxo de caixa tem uma característica temporal, pode ser diário, semanal, mensal, anual, e traz componentes de projeção ou estimativa. É importante considerar os saldos de ciclos anteriores para compor as disponibilidades (ou indisponibilidades) nos ciclos posteriores.' +
                    '<br><br>' +
                    'O fluxo de caixa é uma das mais importantes ferramentas de gestão financeira.  Visa demonstrar e também projetar, em períodos futuros, o resultado de todas as entradas e as saídas de recursos financeiros em regime de caixa (e não contábil).' +
                    '<br><br>' +
                    'Ele permite ao empresário lançar suas contas a pagar e seus direitos a receber, além de estimativas de receitas e despesas, apurando assim o saldo disponível ou mesmo indisponível, permitindo medidas antecipadas de gestão. É um poderoso instrumento gerencial na antecipação de problemas de liquidez e endividamento, sintomático de rentabilidade, lucratividade e eficácia. Quanto maior for a proximidade entre a projeção do fluxo de caixa e o efetivamente realizado, maior será o conhecimento do empresário sobre seu negócio.' +
                    '<br><br>' +
                    'O fluxo de caixa deve ser utilizado como controle e, principalmente, instrumento na tomada de decisões. O empresário deve inserir informações de entradas e saídas conforme as necessidades. Com as informações, é possível elaborar a estrutura gerencial de resultados e a análise de sensibilidade, calcular a rentabilidade e a lucratividade, entre outros pontos.' +
                    '<br><br>' +
                    'Manter as contas em dia é muito importante para a saúde do negócio e para poder planejar uma gestão eficiente.',
                imagem: 'b-icon-chart',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: null,
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            flowcash: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: 'CASHFLOW',
                resumo: 'POSIÇÃO INICIAL DO SEU SALDO!',
                imagem: 'b-icon-dollar',
                stores: null,
                valor$: null,
                select: 'Estou ciente dos termos',
                inputf: {name: 'Saldo inicial', mask: null, type: 'num', size: 0, text: '', money: true},
                action: {name: 'Pronto', round: false, small: true, plus: null},
                observ: observ,
                linhas: [
                    {text: '<b>Posição inicial</b> zera seu histórico.', right: ''},
                    {text: null, right: ''},
                    {text: 'Cashflow calcula <b>os últimos 6 meses</b>.', right: ''},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            servico: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: str,
                resumo: (bool ? 'INFORME O VALOR!' : 'INFORME A PORCENTAGEM!'),
                imagem: (bool ? 'b-icon-dollar' : 'b-icon-percent'),
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'Valor', mask: null, type: 'num', size: 0, text: '', money: true},
                action: {name: 'Pronto', round: false, small: true, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            integra: {
                window: window,
                corcor: 'CorFood',
                header: 'iFood',
                titulo: str,
                resumo: 'Código de Integração',
                imagem: 'https://storage.lorean.com.br/branded/12350/logo.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: {name: 'Ativar API', round: false, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            integre: {
                window: window,
                corcor: 'CorRoxa',
                header: 'Lorean-API',
                titulo: str,
                resumo: 'Nome do Integrador',
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'Nome curto', mask: '', type: 'all', size: 20, text: ''},
                action: {name: 'Ativar API', round: false, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            codeday: {
                window: window,
                corcor: 'CorFood',
                header: null,
                titulo: 'CODEDAY',
                resumo: 'FIXAR CÓDIGO DIMINUI A SEGURANÇA!',
                imagem: 'b-icon-lock',
                stores: null,
                valor$: null,
                select: 'Estou ciente dos termos',
                inputf: {name: 'Código de 3 digitos', mask: '000', type: 'num', size: 3, text: ''},
                action: {name: 'Fixar Código', round: false, small: true, plus: null},
                observ: observ,
                linhas: [
                    {text: '<b>Apenas a STAFF</b> deve saber o código.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Altere</b> se usado por <b>freelance</b>.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Remova o usuário se sair</b> da equipe.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Não utilize</b> números <b>sequenciais</b>.', right: ''},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            workday: {
                window: window,
                corcor: (bool ? 'CorLime' : 'CorFood'),
                header: null,
                titulo: 'WORKDAY',
                resumo: (bool ? 'ABRIR' : 'FECHAR') + ' WORKDAY!',
                imagem: (bool ? 'b-icon-lock-open' : 'b-icon-lock'),
                stores: null,
                valor$: null,
                select: 'Estou ciente da ação',
                inputf: null,
                action: {name: (bool ? 'Abrir' : 'Fechar') + ' Agora', round: false, small: true, plus: null},
                observ: observ,
                linhas: [
                    {text: '<b>Iniciar</b> perto da abertura.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Congelado</b> após <b>18horas</b>.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Freelance</b> removido no Turnday.', right: ''},
                    {text: null, right: ''},
                    {text: '<b>Responsabilidade</b> nessa <b>ação</b>.', right: ''},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            fundir: {
                window: window,
                corcor: 'CorFogo',
                header: null,
                titulo: 'FUNDIR-TICKET',
                resumo: 'NÚMERO DE IDENTIFICAÇÃO!',
                imagem: 'b-icon-credit-card',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'Protocolo', mask: '#0000', type: 'num', size: 5, text: ''},
                action: {name: 'Pronto', round: false, small: true, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            screenshot: {
                window: window,
                corcor: 'CorFood',
                header: null,
                titulo: 'ATENÇÃO',
                resumo: 'SUA CONTA SEGURA!',
                imagem: 'b-icon-qrcode',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: null,
                observ: observ,
                linhas: [
                    {text: '<b>NÃO COMPARTILHE SEU QRCODE</b>, ele é <b>exclusivo</b> para você.', right: ''},
                    {text: null, right: ''},
                    {text: null, right: ''},
                    {text: 'Você pode <b>transferir</b> um voucher. <b>Acesse os vouchers</b>, é fácil e mantém sua conta segura.', right: ''},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            //APP-PUBLISH - nao esta usando onde chama
            pushnotifye: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: 'PRECISAMOS CONVERSAR',
                resumo: 'Quero notificar você para...',
                imagem: 'assets/img/window/wd-handapp-notifye.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: {name: 'Continuar', round: false, small: false, plus: null},
                observ: observ,
                linhas: [
                    {text: 'Controlar sua comanda.', right: ''},
                    {text: 'Promoções e cupons.', right: ''},
                    {text: 'Contatinho conquistado.', right: ''},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            animehtml: {
                window: window,
                corcor: 'CorRoxa',
                header: 'Leia com atenção',
                titulo: null,
                resumo: null,
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: null,
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            animeload: {
                window: window,
                corcor: 'CorDash',
                header: null,
                titulo: 'Preparando tudo',
                resumo: 'Aguarde só mais um pouquinho...',
                imagem: 'assets/img/window/wd-transferir.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: (!bool ? null : {name: 'Editar', round: false, small: true, plus: null}),
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            animeerro: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: 'Não há voucher disponível.',
                resumo: str,
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: (!bool ? null : {name: 'Tentar Novamente', round: false, small: true, plus: null}),
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            memberuser: {
                window: window,
                corcor: memberuser.corcor,
                header: null,
                titulo: ENUM.usuarioRule(false, memberuser.usuario.Departa, memberuser.usuario.UsuarioRole),
                resumo: memberuser.usuario.UsuarioHtml,
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: (!bool ? null : {name: 'Acessar Perfil', round: false, small: false, plus: null}),
                observ: observ,
                linhas: (!bool ? null : [{text: 'CEO e VP tem acesso para alterar', right: ''}]),
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            developer: {
                window: window,
                corcor: 'CorDash',
                header: null,
                titulo: '',
                resumo: '',
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: {name: 'Excluir', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            estorno: {
                window: window,
                corcor: 'CorVerm',
                header: null,
                titulo: 'ESTORNAR PAGAMENTO',
                resumo: 'Você tem certeza? Este processo não tem volta.',
                imagem: 'assets/img/window/wd-phonecard.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: {name: 'Excluir', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            acessofnd: {
                window: window,
                corcor: (!str ? 'CorRoxa' : str),
                header: null,
                titulo: 'Comanda',
                resumo: 'CPF ou número da comanda.',
                imagem: 'b-icon-user-add',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'CPF ou Comanda', mask: '000.000.000-00', type: 'num', size: 14, text: ''},
                action: {name: 'Buscar', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            vouchermov: {
                window: window,
                corcor: 'CorVerm',
                header: null,
                titulo: 'Desistiu?',
                resumo: 'Para transferir, insira o CPF do destinatário.',
                imagem: 'assets/img/window/wd-transferir.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'CPF de Destino', mask: '000.000.000-00', type: 'num', size: 14, text: ''},
                action: {name: 'Transferir', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            consumoMove: {
                window: window,
                corcor: 'CorRoxa',
                header: null,
                titulo: 'Mover Consumo?',
                resumo: 'Para transferir, insira a Comanda de destino.',
                imagem: 'assets/img/window/wd-transferir.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'Número de Destino', mask: '', type: 'num', size: 0, text: ''},
                action: {name: 'Transferir', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            emergency: {
                window: window,
                corcor: 'CorVerm',
                header: 'Emergência',
                titulo: 'Leia com atenção!',
                resumo: 'Se você efetuou o pagamento mas ainda não foi processado libere seu hotspot.',
                imagem: null,
                stores: null,
                valor$: null,
                select: 'Estou ciente dos termos',
                inputf: null,
                action: {name: 'Liberar Agora', round: false, small: false, plus: null},
                observ: observ,
                linhas: [
                    {text: 'Liberado <b>24h</b> para processamento', right: null, color: null},
                    {text: 'Você pode utilizar apenas <b>1 vez</b>', right: null, color: null}
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            assinatura: {
                window: window,
                corcor: 'CorVerm',
                header: 'Cancelamento',
                titulo: 'Leia com atenção!',
                resumo: 'Deseja cancelar seu hotspot?',
                imagem: null,
                stores: null,
                valor$: null,
                select: 'Estou ciente dos termos',
                inputf: null,
                action: {name: 'Cancelar Agora', round: false, small: false, plus: null},
                observ: observ,
                linhas: [
                    {text: 'Sua licença de utilização será <b>cancelada</b>', right: null, color: null},
                    {text: 'Você <b>não</b> poderá utilizar nenhum recurso', right: null, color: null}
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            titularidade: {
                window: window,
                corcor: 'CorVerm',
                header: 'Titularidade',
                titulo: 'Leia com atenção!',
                resumo: 'Deseja transferir seu hotspot?',
                imagem: null,
                stores: null,
                valor$: null,
                select: 'Estou ciente dos termos',
                inputf: null,
                action: {name: 'Transferir Agora', round: false, small: false, plus: null},
                observ: observ,
                linhas: [
                    {text: 'Você <b>não será mais dono</b> desse hotspot', right: null, color: null},
                    {text: 'Esse processo <b>não tem volta</b>', right: null, color: null}
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            premiumsync: {
                window: window,
                corcor: 'CorRoxa',
                header: 'Premium',
                titulo: null,
                resumo: null,
                imagem: null,
                stores: null,
                valor$: {real: 'R$ 200', info: null},
                select: null,
                inputf: null,
                action: {name: 'Adquirir', round: false, small: false, plus: null},
                observ: observ,
                linhas: [
                    {text: 'User B2C - Exemplo - 3 Bizoiada em perfil alheio', right: ''},
                    {text: 'User B2C', right: ''},
                    {text: 'User B2C', right: ''},
                    {text: 'User B2C', right: ''},
                    {text: 'User B2C', right: ''}
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            gatecharge: {
                window: window,
                corcor: 'CorVerm',
                header: null,
                titulo: 'Chargeback?',
                resumo: 'Informe a data da ocorrencia.',
                imagem: 'assets/img/window/wd-phonecard.png',
                stores: null,
                valor$: null,
                select: 'Confirmo chargeback',
                inputf: {name: 'Data Devolução', mask: '00/00/0000', type: 'num', size: 10, text: ''},
                action: {name: 'Chargeback', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            gatewaypay: {
                window: window,
                corcor: (bool ? 'CorWeek' : 'CorRoxa'),
                header: null,
                titulo: (bool ? 'Payroll' : 'Resgate'),
                resumo: null,
                imagem: 'assets/img/window/wd-money.png',
                stores: null,
                valor$: {real: 'R$ 0,00', info: str},
                select: (bool ? null : 'Entendi, <b>quero resgatar</b>.'),
                inputf: null,
                action: {name: (bool ? 'Pagar' : 'Resgatar'), round: false, small: false, plus: null},
                observ: observ,
                linhas: null,
                // linhas: [
                //     {text: 'Taxa de Antecipação:', right: '<b>R$ 0,00</b>', color: null},
                // ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            loreanpay: {
                window: window,
                corcor: 'CorRoxa',
                header: 'Taxas',
                titulo: null,
                resumo: null,
                imagem: 'assets/img/logo/loreanpay.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: (!bool ? null : {name: 'Editar', round: false, small: true, plus: null}),
                observ: observ,
                linhas: [
                    {text: 'Resgate:', right: '<b>R$ 0,00</b>'},
                    {text: 'Antecipação:', right: '<b>5%</b>'},
                    {text: 'Payout Serviço:', right: '<b>10%</b>'},
                    {text: 'Ticket Serviço:', right: '<b>10%</b>'},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            profilefnd: {
                window: window,
                corcor: 'CorDash',
                header: 'Perfil',
                titulo: null,
                resumo: (str && str.length == 14 ? 'Informe o CPF' : 'Informe o CNPJ'),
                imagem: null,
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: util.traduzDOC(str), mask: str, type: 'num', size: (!str ? 0 : str.length), text: ''},
                action: {name: 'Localizar', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            profileoff: {
                window: window,
                corcor: (bool ? 'CorVerm' : 'CorWeek'),
                header: (bool ? 'Excluir Conta' : 'Desativar Conta'),
                titulo: null,
                resumo: str,
                imagem: null,
                stores: null,
                valor$: null,
                select: 'Concordo e quero continuar.',
                inputf: {name: 'Senha', mask: null, type: 'num', size: 8, text: ''},
                action: {name: 'Pronto', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            youtube: {
                window: window,
                corcor: 'CorTube',
                header: null,
                titulo: 'Youtube Link',
                resumo: 'Insira o codigo do video.',
                imagem: 'b-icon-youtube',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'code', mask: null, type: 'all', size: null, text: ''},
                action: {name: 'Buscar', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            spotify: {
                window: window,
                corcor: 'CorWhat',
                header: null,
                titulo: 'Spotify Link',
                resumo: 'Insira o codigo da playlist.',
                imagem: 'b-icon-spotify',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'code', mask: null, type: 'all', size: null, text: ''},
                action: {name: 'Buscar', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            fiscal: {
                window: window,
                corcor: 'CorWhat',
                header: null,
                titulo: data.name,
                resumo: 'Insira o código.',
                imagem: 'b-icon-percent',
                stores: null,
                valor$: null,
                select: null,
                inputf: {name: 'code', mask: data.mask, type: 'num', size: data.size, text: ''},
                action: {name: 'Buscar', round: true, small: false, plus: null},
                observ: observ,
                linhas: null,
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            showtime: {
                window: window,
                corcor: 'CorWeek',
                header: str,
                titulo: 'Leia com atenção!',
                resumo: 'Siga as intruções',
                imagem: 'b-icon-qrcode',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: null,
                observ: observ,
                linhas: [
                    {title: 'NA SMART TV', right: null, color: 'CorRoxa'},
                    {text: 'Acesse <b>www.lorean.com.br/show</b>', right: null, color: null},
                    {text: null, right: null, color: null},
                    {title: 'NO CELULAR', right: null, color: 'CorRoxa'},
                    {text: 'Clique no <b>ícone de TV</b>.', right: null, color: null},
                    {text: 'Aponte a <b>Câmera</b> para o QRCode.', right: null, color: null},
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

            liacheckin: {
                window: window,
                corcor: 'CorDark', //'CorMilk',
                header: null,
                titulo: 'Eu sou o <b>DEEP-BUG</b>',
                resumo: 'O PET digital que controla o <b>APP</b>.</br>Se aparecer um <b>BUG</b> eu mato ele.',
              //resumo: 'A inteligência que controla o <b>LOREAN</b>.</br>Meu <b>mundo é todo digital</b>.',
                imagem: 'assets/img/icon/ic-coruja-olha.png', //'assets/img/window/wd-liacover.png',
                stores: null,
                valor$: null,
                select: null,
                inputf: null,
                action: null,
                observ: observ,
                linhas: [
                    //{title: 'DO IT YOURSELF:', right: null, color: 'CorRoxa'},
                    {text: 'Entrar e sair com seu celular!', right: null, color: null},
                    {text: 'Fazer pedido!', right: null, color: null},
                    {text: 'Pagar sua conta!', right: null, color: null},
                    {text: 'Registrar momentos na TV!', right: null, color: null},
                    {text: 'Socializar com as pessoas do spot!', right: null, color: null},

                    /*
                    {title: 'Agora, o que você pode fazer:', right: null, color: 'CorRoxa'},
                    {text: 'Entrar em um lugar!', right: null, color: null},
                    {text: 'Fazer pedido!', right: null, color: null},
                    {text: 'Pagar sua conta!', right: null, color: null},
                    {text: 'Registrar momentos na TV!', right: null, color: null},
                    {text: 'Explorar quem está no spot!', right: null, color: null},
                     */
                ],
                object: null,
                onOkey: onOkey,
                onPlus: onPlus,
            },

        };

        return resultData[window];
    }

}



// WEBPACK FOOTER //
// ./src/app/config.ts